import $ from 'jquery';
export default function int_actuality(){
    $('.actualite-item_read-more button').click(function(){
        $('.actualite-item.current-item').toggleClass('show-all')
    })
    $(document).ready(function() {
        $(window).scroll(function() {
			if( $('.actualite-years').length ) {
				var h_element = $('.actualite-years')[0].getBoundingClientRect().height;
				var top_container = $('html')[0].getBoundingClientRect().top;
				var top_footer = $('footer')[0].getBoundingClientRect().top;
				var has_class = $('.actualite-years').hasClass('sticky');
				if (top_container <= -562  && !has_class && top_footer > h_element) {
					$('.actualite-years').addClass('sticky');
					$('.actualite-years').removeClass('bottom');

				}else if( top_container > -562 ){
					$('.actualite-years').removeClass('sticky');

				}else if(top_footer <= h_element){
					$('.actualite-years').removeClass('sticky');
					$('.actualite-years').addClass('bottom');
				}
			}
        })

		var navigationItems = document.querySelectorAll('.sidebar-nav-item');
		var sectionsItems = document.querySelectorAll('.actualite-item');

		$(sectionsItems).each(function(index){
			var navSec = sectionsItems[index];
			var navBut = navigationItems[index];
		  
			$(window).scroll(function(){
			  var navPos = $(navSec).offset().top;
			  var secBot = navPos + $(navSec).outerHeight(true);
			  if ($(this).scrollTop() > navPos && $(this).scrollTop() < secBot){
				$(navBut).parent().addClass('active');
				if(!$(navBut).parent().hasClass('active-initial')){
				$('.active-initial').removeClass('active-initial');
				}
			  }
		  
			  else {
				$(navBut).parent().removeClass('active');
			  }
			});
			$(navBut).click(function(){
				var element = document.getElementById($(navBut).attr('data-id'));
				var headerOffset = -1;
				var elementPosition = element.getBoundingClientRect().top;
				var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
				window.scrollTo({
					top: offsetPosition
				});	
				$(navBut).parent().addClass('active');
				})
		  
		});
    })
    

}